import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.detail || "Invalid credentials");
        setLoading(false);
        return;
      }
      localStorage.setItem("admin_token", data.token);
      navigate("/admin/dashboard");
    } catch {
      setError("Connection failed. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#f5f7fa] flex items-center justify-center" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src="/logo_compact.png" alt="Opturna Tax AI" className="h-12 rounded-lg mx-auto mb-4" data-testid="admin-logo" />
          <p className="text-sm text-[#5a6577] mt-1">Admin Console</p>
        </div>

        <form onSubmit={handleLogin} className="bg-white rounded-xl p-6 border border-[#e4e8ee] shadow-sm">
          <h2 className="text-base font-semibold text-[#1e3a5f] mb-5">Sign in to Admin</h2>

          {error && (
            <div className="mb-4 p-3 rounded-lg bg-red-50 border border-red-200 text-red-600 text-xs" data-testid="admin-login-error">
              {error}
            </div>
          )}

          <div className="space-y-4">
            <div>
              <label className="text-xs font-medium text-[#5a6577] block mb-1.5">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-3 py-2.5 rounded-lg bg-[#f5f7fa] border border-[#e4e8ee] text-[#1e3a5f] text-sm placeholder-[#8b95a5] focus:outline-none focus:ring-1 focus:ring-[#1e3a5f]/20 focus:border-[#1e3a5f]/30 transition-colors"
                placeholder="admin@opturnatech.com"
                required
                data-testid="admin-email-input"
              />
            </div>
            <div>
              <label className="text-xs font-medium text-[#5a6577] block mb-1.5">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3 py-2.5 rounded-lg bg-[#f5f7fa] border border-[#e4e8ee] text-[#1e3a5f] text-sm placeholder-[#8b95a5] focus:outline-none focus:ring-1 focus:ring-[#1e3a5f]/20 focus:border-[#1e3a5f]/30 transition-colors"
                placeholder="Enter password"
                required
                data-testid="admin-password-input"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full mt-6 py-2.5 rounded-lg bg-[#1e3a5f] hover:bg-[#2d5a8e] text-white text-sm font-medium transition-colors disabled:opacity-50"
            data-testid="admin-login-btn"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <p className="text-center text-[10px] text-[#8b95a5] mt-6">Restricted access. Authorized personnel only.</p>
      </div>
    </div>
  );
};

export default AdminLogin;
